<template>
  <section>
    <base-card><h2>😔 Page Not Found</h2></base-card>
  </section>
</template>

<style scoped>
section {
  display: flex;
  justify-content: center;
}
</style>
